export default {"src":"/pro/_next/static/media/wbtc.26fa6314.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};